import { SharedService } from './../../services/shared.service';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-detail-video',
  templateUrl: './detail-video.component.html',
  styleUrls: ['./detail-video.component.css']
})
export class DetailVideoComponent implements OnInit {

  @Input() projection: any;

  constructor(private sanitizer: DomSanitizer, private sharedService:SharedService){

  }
  
  getVideoSafeUrl(url: string | undefined): SafeResourceUrl {
    let safeUrl:SafeResourceUrl = '';

    if(url){
      if(this.isVimeoUrl(url)) {
        safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.parseVimeoUrl(url)
        );

        return safeUrl;
      }

      safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.parseSortYoutubeUrl(url)
      );

      if(url?.includes('www.youtube.com')){
        safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.parseYoutubeUrl(url)
        );
      }
    }

    return safeUrl;
  }

  parseYoutubeUrl(url: string): string {
    return url.replace('www.youtube.com/watch?v=', 'www.youtube.com/embed/');
  }

  parseSortYoutubeUrl(url: string): string {
    return url.replace('youtu.be/', 'www.youtube.com/embed/');
  }

  parseVimeoUrl(url: string): any {
    return url.replace('vimeo.com/', 'player.vimeo.com/video/');
  }

  isVimeoUrl(url: string) {
    return url.includes('vimeo');
  }

  isValidUrl(string) {
    try {
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  }

  ngOnInit(): void {
  }

}
